export enum EFieldToneRule {
  NEUTRAL = "NEUTRAL",
  CRITICAL_WHEN_ZERO = "CRITICAL_WHEN_ZERO",
  POSITIVE_WHEN_ACTIVATED = "POSITIVE_WHEN_ACTIVATED",
  POSITIVE_WHEN_YES = "POSITIVE_WHEN_YES"
}
